module.exports = __webpack_public_path__ + "img/org_design_banner.c2288b8b.jpg";